import React, { useRef } from 'react'
import { useDrop } from 'react-dnd'

export const ItemType = 'leadd_qual_field'

interface DraggableGoalItemProps {
  index: number
  moveGoal: (from: number, to: number) => void
  children: React.ReactNode
}

export const DraggableField = ({ index, moveGoal, children }: DraggableGoalItemProps) => {
  const ref = useRef<HTMLLIElement>(null)

  const [, drop] = useDrop({
    accept: ItemType,
    hover(item: { index: number }, monitor) {
      if (!ref.current) {
        return
      }

      const dragIndex = item.index
      const hoverIndex = index

      if (dragIndex === hoverIndex) {
        return
      }

      const hoverRect = ref.current.getBoundingClientRect()
      const hoverMiddleY = (hoverRect.bottom - hoverRect.top) / 2
      const clientOffset = monitor.getClientOffset()

      if (clientOffset === null) {
        return
      }

      const hoverClientY = clientOffset.y - hoverRect.top

      if (
        (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) ||
        (dragIndex > hoverIndex && hoverClientY > hoverMiddleY)
      ) {
        return
      }

      moveGoal(dragIndex, hoverIndex)
      item.index = hoverIndex
    },
    collect: (monitor) => {
      return {
        isDrop: monitor.canDrop(),
      }
    },
  })

  drop(ref)

  return <li ref={ref}>{children}</li>
}
